import { Marker } from "@vis.gl/react-maplibre";
import type { FC } from "react";
import { useRecoilValue } from "recoil";

import { investigationHighlightedStationIdsAtom } from "@ryde/shared";

import { selectHighlightedStations } from "../investigation.history.utils";
import type { TPlacedPlaybackStation } from "../investigation.models";
import { StationHighlightRingStyled } from "./investigation.map.styled";

interface IInvestigationHighlightedStationsProps {
  stations: TPlacedPlaybackStation[];
}

/** Rings the stops the selected Timeline row is about. */
export const InvestigationHighlightedStations: FC<
  IInvestigationHighlightedStationsProps
> = ({ stations }) => {
  const stationIds = useRecoilValue(investigationHighlightedStationIdsAtom);

  return (
    <>
      {selectHighlightedStations({ stations, stationIds }).map(entry => (
        <Marker
          key={entry.station.id}
          className="investigation-station-highlight"
          longitude={entry.latLng[1]}
          latitude={entry.latLng[0]}
          anchor="center"
          pitchAlignment="viewport"
          rotationAlignment="viewport"
        >
          <StationHighlightRingStyled />
        </Marker>
      ))}
    </>
  );
};
